import React, {useEffect ,useState} from 'react';
import {useSelector} from 'react-redux';

import styles from './styles/modal.module.css';

import DatabaseCommon from './DatabaseCommon';
import DatabaseInfo from './DatabaseInfo';
import DatabaseTest from './DatabaseTest';
import DatabaseType from './DatabaseType';

export default function CreateModal({ currentStepName, setCurrentStepName, initialInfo, connectionInfo, setConnectionInfo, listResponse, listLoading, handleReload, toggleAddModal }) {
    const { connectNewResponse, connectNewError, saveError, updateError, connectNewDBLoading, connectNewSQLiteLoading, saveDBLoading, saveSQLiteLoading, updateDBLoading, updateSQLiteLoading } = useSelector(({ database, loading }) => ({
        connectNewResponse: database.connectNewResponse,
        connectNewError: database.connectNewError,
        saveError: database.saveError,
        updateError: database.updateError,
        connectNewDBLoading: loading['database/CONNECT_NEW_DB'],
        connectNewSQLiteLoading: loading['database/CONNECT_NEW_SQLITE'],
        saveDBLoading: loading['database/SAVE_DB'],
        saveSQLiteLoading: loading['database/SAVE_SQLITE'],
        updateDBLoading: loading['database/UPDATE_DB'],
        updateSQLiteLoading: loading['database/UPDATE_SQLITE']
    }));

    const [aliasNameList, setAliasNameList] = useState([]); // 별칭 중복 검사를 위한 별칭 이름 목록

    const changeConnectionInfo = (name, value) => { // connectionInfo 값을 변경하는 함수
        setConnectionInfo(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const initializeConnectionInfo = () => { // connectionInfo 초기화하는 함수
        setConnectionInfo(initialInfo);
    };

    const getSubTitleInTestStep = () => {
        if (saveDBLoading || saveSQLiteLoading || updateDBLoading || updateSQLiteLoading) return '저장 중이에요! 잠시만 기다려주세요';
        if (!saveDBLoading && !saveSQLiteLoading && saveError) return '저장에 실패했어요! 재시도를 누르면 다시 저장이 되어요';
        if (!updateDBLoading && !updateSQLiteLoading && updateError) return '저장에 실패했어요! 재시도를 누르면 다시 저장이 되어요';
        if (!connectNewDBLoading && !connectNewSQLiteLoading && connectNewResponse) return '연결에 성공했어요! 저장을 누르면 리스트에 반영되어요';
        if (!connectNewDBLoading && !connectNewSQLiteLoading && connectNewError) return '연결에 실패했어요! 확인을 누르면 연결 정보 입력 페이지로 돌아가요';

        return '데이터베이스 서버와 연결하고 있어요. 최대 3분이 소요될 수 있어요';
    };

    const stepMap = [ // DB 연결 과정 정보
        {
            id: 1, 
            name: 'type', 
            title: 'DB 종류 선택',
            subTitle: '연결하고자 하는 데이터베이스 유형을 선택하세요',
            component: 
                <DatabaseType 
                    setCurrentStepName={setCurrentStepName}
                    changeConnectionInfo={changeConnectionInfo}
                />
        },
        { 
            id: connectionInfo.id ? 1 : 2, 
            name: 'info', 
            title: '연결 정보 입력', 
            subTitle: '연결에 필요한 정보를 입력하세요', 
            component: 
                <DatabaseInfo
                    connectionInfo={connectionInfo}
                    aliasNameList={aliasNameList}
                    setCurrentStepName={setCurrentStepName}
                    changeConnectionInfo={changeConnectionInfo}
                    initializeConnectionInfo={initializeConnectionInfo}
                    toggleAddModal={toggleAddModal}
                />
        },
        {
            id: connectionInfo.id ? 2 : 3, 
            name: 'test',
            title: '연결 테스트',
            subTitle: getSubTitleInTestStep(),
            component: 
                <DatabaseTest 
                    connectionInfo={connectionInfo}
                    setCurrentStepName={setCurrentStepName}
                    handleReload={handleReload}
                    toggleAddModal={toggleAddModal}
                />
        }
    ];

    const findCurrentStep = stepMap.find(
        step => step.name === currentStepName
    );

    const clickBackground = (e) => {
        if (e.target === e.currentTarget) {
            toggleAddModal();
        }
    };

    useEffect(() => {
        if (!listLoading && listResponse) {
            setAliasNameList(listResponse.map(item => item.aliasName));
        }
    }, [listResponse, listLoading]);

    return (
        <div className={styles.wrapper} onClick={clickBackground}>
            <div className={styles.containerModal} data-type={currentStepName ?? 'default'} onClick={(e) => e.stopPropagation()}>
                {currentStepName && 
                    <DatabaseCommon
                        stepLength={connectionInfo.id ? stepMap.length - 1 : stepMap.length}
                        currentStep={findCurrentStep}
                        setCurrentStepName={setCurrentStepName}
                    />
                }
            </div>
        </div>
    );
}
